// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.centered {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.progress-circle{
    position: absolute;
    z-index: 100;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%)
}

.slide-container {
    margin-top: 30px;
    height: 600px;
}

.c240-slide-container {
    margin-top: 15px;
    height: 465px;
}

.c240-horizontal-slide-container {
    width: 530px;
    display: flex;
    flex-direction: row;
    justify-content: center;
     /* 511.5px; */
}

.empty-confirmed-container-auto-preview-threshold {
    height: 570px;
}

.empty-confirmed-preview-container {
    height: 595px;
}

.empty-confirmed-preview-container, .empty-confirmed-container-auto-preview-threshold {
    /* height: 595px; */
    width: 160px;
    border: 2px solid;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #1890ff1a;
    padding: 5px;
    box-shadow: 0 -2px 8px 1px #5a1fa6;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}


.empty-confirmed-preview-container-2by3 {
    height: 595px;
    width: 280px;
    border: 2px solid;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #1890ff1a;
    padding: 5px;
    box-shadow: 0 -2px 8px 1px #5a1fa6;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}

.empty-unconfirmed-container-auto-preview-threshold {
    height: 570px;
}

.empty-unconfirmed-preview-container {
    height: 595px;
}

.empty-unconfirmed-preview-container, .empty-unconfirmed-container-auto-preview-threshold {
    /* height: 595px; */
    width: 160px;
    border: 2px solid;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #1890ff1a;
    padding: 5px;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}


.empty-unconfirmed-preview-container-2by3 {
    height: 595px;
    width: 280px;
    border: 2px solid;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #1890ff1a;
    padding: 5px;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}

.c240-empty-confirmed-preview-container {
    height: 446px;
    width: 120px;
    border: 2px solid;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #1890ff1a;
    padding: 5px;
    box-shadow: 0 4px 8px 2px green;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}

.c240-horizontal-empty-confirmed-preview-container {
    height: 119px;
    width: 510px;
    /* height: 119px; */
    /* width: 380px; */
    /* 490.6px;; */
    /* border: 2px solid; */
    margin-top: 10px;
    margin-bottom: 10px;
    /* background-color: #1890ff1a; */
    padding: 5px;
    /* box-shadow: 0 4px 8px 2px green; */
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}

.c240-empty-confirmed-preview-container-2by3 {
    /* height: 446px;
    width: 240px; */
    /* border: 2px solid; */
    margin-top: 10px;
    margin-bottom: 10px;
    /* background-color: #1890ff1a; */
    padding: 5px;
    /* box-shadow: 0 4px 8px 2px green; */
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}

.c240-empty-unconfirmed-preview-container {
    height: 446px;
    width: 120px;
    border: 2px solid;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #1890ff1a;
    padding: 5px;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}

.c240-horizontal-empty-unconfirmed-preview-container {
    height: 119px;
    width: 510px;
    /* 490.6px; */
    /* border: 2px solid; */
    margin-top: 10px;
    margin-bottom: 10px;
    /* background-color: #1890ff1a; */
    padding: 5px;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}

.c240-empty-unconfirmed-preview-container-2by3 {
    /* height: 446px;
    width: 446px; */
    /* border: 2px solid; */
    margin-top: 10px;
    margin-bottom: 10px;
    /* background-color: #1890ff1a; */
    padding: 5px;
    transition-duration: 200ms;
    transition-timing-function: ease-in;
}

.filled-container-auto-preview-threshold {
    height: 570px;
}

.filled-preview-container {
    height: 595px;
}

.filled-preview-container, .filled-container-auto-preview-threshold {
    /* height: 595px; */
    width: 166px;
    border: 2px solid;
    background-size: 100%;
    background-position-y: center;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
}

.c240-filled-preview-container {
    height: 446px;
    width: 120px;
    border: 2px solid;
    background-size: 100%;
    background-position-y: center;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
}

.c240-horizontal-filled-preview-container {
    height: 119px;
    width: 510px;
    /* 490.6px; */
    /* border: 2px solid; */
    /* background-size: 100%; */
    /* background-position-y: center; */
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
}

.c240-filled-preview-container-2by3 {
    /* height: 446px;
    width: 240px; */
    /* border: 2px solid; */
    background-size: 100%;
    background-position-y: center;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
}


.confirmed-preview-slide {
    height: 595px;
    width: 166px;
    border: 2px solid;
    background-size: 100%;
    background-position-y: center;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 5px;
    box-shadow: 5px 10px green;
}

.empty-slide {
    height: 350px;
}

.horizontal-empty-slide {
    width: 275px;
    height: 113px;
    background-color: #1890ff1a;
    margin-left: 10px;
    /* 385px; */
}

.horizontal-empty-slide-2by3 {
    width: 300px;
    height: 200px;
    background-color: #1890ff1a;
    margin-left: 5px;
    /* 385px; */
}

.filled-slide {
    height: 350px;
    cursor: pointer;
}

.horizontal-filled-slide {
    width: 275px;
    height: 113px;
    margin-left: 10px;
    /* 385px; */
    position: relative;
    cursor: pointer;
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/
}

.horizontal-filled-slide-2by3 {
    width: 300px;
    height: 200px;
    margin-left: 5px;
    /* 385px; */
    position: relative;
    cursor: pointer;
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: center;*/
}

.filled-slide > p {
    margin-bottom: 0;
}

.filled-action-ongoing-slide {
    height: 350px;
}

.filled-action-ongoing-slide > p {
    margin-bottom: 0;
}

.slot-image-blood {
    height: 319px;
    width: 130px;
    /* transform: rotate(90deg); */
    margin-left: 25px;
    margin-top: 25px;
    padding: 0 2px 0 2px;
}

.slot-image {
    height: 146px;
    width: 319px;
    transform: rotate(90deg);
    margin-left: -83px;
    margin-top: 95px;
    padding: 0 2px 0 2px;
}

.filled-preview-container-2by3 .slot-image {
    height: 210px;
    width: 315px;
    transform: rotate(90deg);
    margin-left: -25px;
    margin-top: 62px;
    padding: 0 2px 0 2px;
}

.c240-slot-image {
    height: 114px;
    width: 250px;
    transform: rotate(90deg);
    margin-left: -72px;
    margin-top: 80px;
    padding: 0 2px 0 2px;
}

.c240-horizontal-slot-image {
    width: 275px;
    height: 113px;
    transform: rotate(0deg);
    /* margin-top: -72px;
    margin-left: 80px; */
}

.c240-horizontal-slot-image-canvas {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
}

.c240-horizontal-slot-image-canvas-2by3 {
    width: 250px;
    height: 200px;
    background-size: 100% 100%;
}

.c240-filled-preview-container-2by3 .c240-slot-image, 
.c240-empty-unconfirmed-preview-container-2by3 .c240-slot-image, 
.c240-empty-confirmed-preview-container-2by3 .c240-slot-image {
    /* height: 222px;
    width: 314px; */
    transform: rotate(90deg);
    margin-left: -44px;
    margin-top: 58px;
    padding: 0 2px 0 2px;
}

.barcode-filled {
    border-top: 1px solid grey;
    height: 150px ;
    width: 146px;
    margin-bottom: 0;
    position: relative;
    cursor: pointer;
}

.c240-barcode-filled {
    height: 115px !important;
    width: 110px !important;
    margin-bottom: 0;
    position: relative;
    cursor: pointer;
}

.c240-horizontal-barcode-filled {
    /* border-left: 1px solid grey; */
    margin-left: 10px;
    height: 113px !important;
    width: 113px !important;
    position: relative;
    cursor: pointer;
}

.barcode-empty {
    border-top: 1px solid grey;
    height: 150px;
    width: 146px;
    background-color: #6495ed36;
}

.c240-barcode-empty {
    border-top: 1px solid grey;
    height: 85px;
    width: 105px;
    background-color: #6495ed36;
}

.c240-horizontal-barcode-empty-2by3 {
    margin-left: 10px;
    height: 200px !important;
    width: 113px !important;
    background-color: #6495ed36;
}

.c240-horizontal-barcode-filled-2by3 {
    margin-left: 10px;
    height: 200px !important;
    width: 113px !important;
    /* background-color: #6495ed36; */
}

.c240-horizontal-barcode-empty {
    margin-left: 10px;
    height: 113px !important;
    width: 113px !important;
    background-color: #6495ed36;
}

.barcode-image {
    padding: 0 0 2px 0;
    height: inherit;
    width: inherit;
}

.horizontal-barcode-image {
    height: inherit;
    width: inherit;
    transform: rotate(-90deg);
}

.c240-horizontal-slide-status{
    height: 113px;
    background-color: grey;
    margin-left: 10px;
}

.c240-horizontal-slide-status-2by3{
    height: 200px;
    background-color: grey;
    margin-left: 10px;
}

.quick-settings-button-group {
    width: 100%;
    background-color: white;
}

.quick-settings-button {
    height: 20px; 
    width: 100%;
}

/* .checkbox {
    margin: -20px;
    padding: 0 !important;
} */

.checkbox >  span {
    padding: 0 !important;
}

.barcode-filled:hover .rotate {
	display: block;
}

.c240-barcode-filled:hover .rotate {
    display: block;
}

.rotate {
    position: absolute;
    left: 33%;
    top: 30%;
    display: none;
    font-size: 50px;
}

.ant-input-number-input {
    height: 22px;
}

.scan {
    /* width: 10; */
    /* text-align: center; */
    /* padding: 6px 2px; */
    /* position: absolute; */
    left: 0;
    right: 0;
    /* top: 50%; */
    margin: auto;

    opacity: 0.5;
    /* #border: dashed .25em rgb(90, 85, 85); */
    /* transform: translate(-50%); */
}

.scan::after {
    content: '';
    background: rgb(211, 44, 135);
    width: 8px;
    height: 100px;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    opacity: 7;
    z-index: 2;
    animation: 3s infinite ease-in-out roll;
}

.scan > .c240-horizontal-slide-container {
    /* height: 50px;
    width: 98%; */
    opacity: 0.5;
}

@keyframes roll {
    0% {
        transform: translateX(-140px);
    }
    50% {
        transform: translateX(135px);
    }
    100% {
        transform: translateX(-140px);
    }
}

.lds-spinner {
    color: official;
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}

.lds-spinner div {
    transform-origin: 40px 40px;
    animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 37px;
    width: 6px;
    height: 18px;
    border-radius: 20%;
    background: #fff;
}

.lds-spinner div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
}

.lds-spinner div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
}

.lds-spinner div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
}

.lds-spinner div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
}

.lds-spinner div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
}

.lds-spinner div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
}

.lds-spinner div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
}

.lds-spinner div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
}

.lds-spinner div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
}

.lds-spinner div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
}

.lds-spinner div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
}

.lds-spinner div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
}

@keyframes lds-spinner {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/workflow/slide.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;KACtB,aAAa;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,kCAAkC;IAClC,0BAA0B;IAC1B,mCAAmC;AACvC;;;AAGA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,kCAAkC;IAClC,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,0BAA0B;IAC1B,mCAAmC;AACvC;;;AAGA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,+BAA+B;IAC/B,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,YAAY;IACZ,qCAAqC;IACrC,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI;mBACe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,YAAY;IACZ,qCAAqC;IACrC,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,YAAY;IACZ,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI;mBACe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,YAAY;IACZ,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;mBACe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB;wBACoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,0BAA0B;AAC9B;;AAEA;;;IAGI;mBACe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;;;GAGG;;AAEH;IACI,qBAAqB;AACzB;;AAEA;CACC,cAAc;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,sBAAsB;IACtB,wBAAwB;IACxB,OAAO;IACP,QAAQ;IACR,cAAc;IACd,YAAY;;IAEZ,YAAY;IACZ,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,UAAU;IACV,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS;IACT,YAAY;IACZ,UAAU;IACV,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI;iBACa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,6BAA6B;IACjC;IACA;QACI,4BAA4B;IAChC;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".centered {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n}\n\n.progress-circle{\n    position: absolute;\n    z-index: 100;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%)\n}\n\n.slide-container {\n    margin-top: 30px;\n    height: 600px;\n}\n\n.c240-slide-container {\n    margin-top: 15px;\n    height: 465px;\n}\n\n.c240-horizontal-slide-container {\n    width: 530px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n     /* 511.5px; */\n}\n\n.empty-confirmed-container-auto-preview-threshold {\n    height: 570px;\n}\n\n.empty-confirmed-preview-container {\n    height: 595px;\n}\n\n.empty-confirmed-preview-container, .empty-confirmed-container-auto-preview-threshold {\n    /* height: 595px; */\n    width: 160px;\n    border: 2px solid;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    background-color: #1890ff1a;\n    padding: 5px;\n    box-shadow: 0 -2px 8px 1px #5a1fa6;\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n\n.empty-confirmed-preview-container-2by3 {\n    height: 595px;\n    width: 280px;\n    border: 2px solid;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    background-color: #1890ff1a;\n    padding: 5px;\n    box-shadow: 0 -2px 8px 1px #5a1fa6;\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n.empty-unconfirmed-container-auto-preview-threshold {\n    height: 570px;\n}\n\n.empty-unconfirmed-preview-container {\n    height: 595px;\n}\n\n.empty-unconfirmed-preview-container, .empty-unconfirmed-container-auto-preview-threshold {\n    /* height: 595px; */\n    width: 160px;\n    border: 2px solid;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    background-color: #1890ff1a;\n    padding: 5px;\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n\n.empty-unconfirmed-preview-container-2by3 {\n    height: 595px;\n    width: 280px;\n    border: 2px solid;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    background-color: #1890ff1a;\n    padding: 5px;\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n.c240-empty-confirmed-preview-container {\n    height: 446px;\n    width: 120px;\n    border: 2px solid;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    background-color: #1890ff1a;\n    padding: 5px;\n    box-shadow: 0 4px 8px 2px green;\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n.c240-horizontal-empty-confirmed-preview-container {\n    height: 119px;\n    width: 510px;\n    /* height: 119px; */\n    /* width: 380px; */\n    /* 490.6px;; */\n    /* border: 2px solid; */\n    margin-top: 10px;\n    margin-bottom: 10px;\n    /* background-color: #1890ff1a; */\n    padding: 5px;\n    /* box-shadow: 0 4px 8px 2px green; */\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n.c240-empty-confirmed-preview-container-2by3 {\n    /* height: 446px;\n    width: 240px; */\n    /* border: 2px solid; */\n    margin-top: 10px;\n    margin-bottom: 10px;\n    /* background-color: #1890ff1a; */\n    padding: 5px;\n    /* box-shadow: 0 4px 8px 2px green; */\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n.c240-empty-unconfirmed-preview-container {\n    height: 446px;\n    width: 120px;\n    border: 2px solid;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    background-color: #1890ff1a;\n    padding: 5px;\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n.c240-horizontal-empty-unconfirmed-preview-container {\n    height: 119px;\n    width: 510px;\n    /* 490.6px; */\n    /* border: 2px solid; */\n    margin-top: 10px;\n    margin-bottom: 10px;\n    /* background-color: #1890ff1a; */\n    padding: 5px;\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n.c240-empty-unconfirmed-preview-container-2by3 {\n    /* height: 446px;\n    width: 446px; */\n    /* border: 2px solid; */\n    margin-top: 10px;\n    margin-bottom: 10px;\n    /* background-color: #1890ff1a; */\n    padding: 5px;\n    transition-duration: 200ms;\n    transition-timing-function: ease-in;\n}\n\n.filled-container-auto-preview-threshold {\n    height: 570px;\n}\n\n.filled-preview-container {\n    height: 595px;\n}\n\n.filled-preview-container, .filled-container-auto-preview-threshold {\n    /* height: 595px; */\n    width: 166px;\n    border: 2px solid;\n    background-size: 100%;\n    background-position-y: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 5px;\n}\n\n.c240-filled-preview-container {\n    height: 446px;\n    width: 120px;\n    border: 2px solid;\n    background-size: 100%;\n    background-position-y: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 5px;\n}\n\n.c240-horizontal-filled-preview-container {\n    height: 119px;\n    width: 510px;\n    /* 490.6px; */\n    /* border: 2px solid; */\n    /* background-size: 100%; */\n    /* background-position-y: center; */\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 5px;\n}\n\n.c240-filled-preview-container-2by3 {\n    /* height: 446px;\n    width: 240px; */\n    /* border: 2px solid; */\n    background-size: 100%;\n    background-position-y: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 5px;\n}\n\n\n.confirmed-preview-slide {\n    height: 595px;\n    width: 166px;\n    border: 2px solid;\n    background-size: 100%;\n    background-position-y: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding: 5px;\n    box-shadow: 5px 10px green;\n}\n\n.empty-slide {\n    height: 350px;\n}\n\n.horizontal-empty-slide {\n    width: 275px;\n    height: 113px;\n    background-color: #1890ff1a;\n    margin-left: 10px;\n    /* 385px; */\n}\n\n.horizontal-empty-slide-2by3 {\n    width: 300px;\n    height: 200px;\n    background-color: #1890ff1a;\n    margin-left: 5px;\n    /* 385px; */\n}\n\n.filled-slide {\n    height: 350px;\n    cursor: pointer;\n}\n\n.horizontal-filled-slide {\n    width: 275px;\n    height: 113px;\n    margin-left: 10px;\n    /* 385px; */\n    position: relative;\n    cursor: pointer;\n    /*display: flex;*/\n    /*align-items: center;*/\n    /*justify-content: center;*/\n}\n\n.horizontal-filled-slide-2by3 {\n    width: 300px;\n    height: 200px;\n    margin-left: 5px;\n    /* 385px; */\n    position: relative;\n    cursor: pointer;\n    /*display: flex;*/\n    /*align-items: center;*/\n    /*justify-content: center;*/\n}\n\n.filled-slide > p {\n    margin-bottom: 0;\n}\n\n.filled-action-ongoing-slide {\n    height: 350px;\n}\n\n.filled-action-ongoing-slide > p {\n    margin-bottom: 0;\n}\n\n.slot-image-blood {\n    height: 319px;\n    width: 130px;\n    /* transform: rotate(90deg); */\n    margin-left: 25px;\n    margin-top: 25px;\n    padding: 0 2px 0 2px;\n}\n\n.slot-image {\n    height: 146px;\n    width: 319px;\n    transform: rotate(90deg);\n    margin-left: -83px;\n    margin-top: 95px;\n    padding: 0 2px 0 2px;\n}\n\n.filled-preview-container-2by3 .slot-image {\n    height: 210px;\n    width: 315px;\n    transform: rotate(90deg);\n    margin-left: -25px;\n    margin-top: 62px;\n    padding: 0 2px 0 2px;\n}\n\n.c240-slot-image {\n    height: 114px;\n    width: 250px;\n    transform: rotate(90deg);\n    margin-left: -72px;\n    margin-top: 80px;\n    padding: 0 2px 0 2px;\n}\n\n.c240-horizontal-slot-image {\n    width: 275px;\n    height: 113px;\n    transform: rotate(0deg);\n    /* margin-top: -72px;\n    margin-left: 80px; */\n}\n\n.c240-horizontal-slot-image-canvas {\n    width: 100%;\n    height: 100%;\n    background-size: 100% 100%;\n}\n\n.c240-horizontal-slot-image-canvas-2by3 {\n    width: 250px;\n    height: 200px;\n    background-size: 100% 100%;\n}\n\n.c240-filled-preview-container-2by3 .c240-slot-image, \n.c240-empty-unconfirmed-preview-container-2by3 .c240-slot-image, \n.c240-empty-confirmed-preview-container-2by3 .c240-slot-image {\n    /* height: 222px;\n    width: 314px; */\n    transform: rotate(90deg);\n    margin-left: -44px;\n    margin-top: 58px;\n    padding: 0 2px 0 2px;\n}\n\n.barcode-filled {\n    border-top: 1px solid grey;\n    height: 150px ;\n    width: 146px;\n    margin-bottom: 0;\n    position: relative;\n    cursor: pointer;\n}\n\n.c240-barcode-filled {\n    height: 115px !important;\n    width: 110px !important;\n    margin-bottom: 0;\n    position: relative;\n    cursor: pointer;\n}\n\n.c240-horizontal-barcode-filled {\n    /* border-left: 1px solid grey; */\n    margin-left: 10px;\n    height: 113px !important;\n    width: 113px !important;\n    position: relative;\n    cursor: pointer;\n}\n\n.barcode-empty {\n    border-top: 1px solid grey;\n    height: 150px;\n    width: 146px;\n    background-color: #6495ed36;\n}\n\n.c240-barcode-empty {\n    border-top: 1px solid grey;\n    height: 85px;\n    width: 105px;\n    background-color: #6495ed36;\n}\n\n.c240-horizontal-barcode-empty-2by3 {\n    margin-left: 10px;\n    height: 200px !important;\n    width: 113px !important;\n    background-color: #6495ed36;\n}\n\n.c240-horizontal-barcode-filled-2by3 {\n    margin-left: 10px;\n    height: 200px !important;\n    width: 113px !important;\n    /* background-color: #6495ed36; */\n}\n\n.c240-horizontal-barcode-empty {\n    margin-left: 10px;\n    height: 113px !important;\n    width: 113px !important;\n    background-color: #6495ed36;\n}\n\n.barcode-image {\n    padding: 0 0 2px 0;\n    height: inherit;\n    width: inherit;\n}\n\n.horizontal-barcode-image {\n    height: inherit;\n    width: inherit;\n    transform: rotate(-90deg);\n}\n\n.c240-horizontal-slide-status{\n    height: 113px;\n    background-color: grey;\n    margin-left: 10px;\n}\n\n.c240-horizontal-slide-status-2by3{\n    height: 200px;\n    background-color: grey;\n    margin-left: 10px;\n}\n\n.quick-settings-button-group {\n    width: 100%;\n    background-color: white;\n}\n\n.quick-settings-button {\n    height: 20px; \n    width: 100%;\n}\n\n/* .checkbox {\n    margin: -20px;\n    padding: 0 !important;\n} */\n\n.checkbox >  span {\n    padding: 0 !important;\n}\n\n.barcode-filled:hover .rotate {\n\tdisplay: block;\n}\n\n.c240-barcode-filled:hover .rotate {\n    display: block;\n}\n\n.rotate {\n    position: absolute;\n    left: 33%;\n    top: 30%;\n    display: none;\n    font-size: 50px;\n}\n\n.ant-input-number-input {\n    height: 22px;\n}\n\n.scan {\n    /* width: 10; */\n    /* text-align: center; */\n    /* padding: 6px 2px; */\n    /* position: absolute; */\n    left: 0;\n    right: 0;\n    /* top: 50%; */\n    margin: auto;\n\n    opacity: 0.5;\n    /* #border: dashed .25em rgb(90, 85, 85); */\n    /* transform: translate(-50%); */\n}\n\n.scan::after {\n    content: '';\n    background: rgb(211, 44, 135);\n    width: 8px;\n    height: 100px;\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    margin: auto;\n    opacity: 7;\n    z-index: 2;\n    animation: 3s infinite ease-in-out roll;\n}\n\n.scan > .c240-horizontal-slide-container {\n    /* height: 50px;\n    width: 98%; */\n    opacity: 0.5;\n}\n\n@keyframes roll {\n    0% {\n        transform: translateX(-140px);\n    }\n    50% {\n        transform: translateX(135px);\n    }\n    100% {\n        transform: translateX(-140px);\n    }\n}\n\n.lds-spinner {\n    color: official;\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n}\n\n.lds-spinner div {\n    transform-origin: 40px 40px;\n    animation: lds-spinner 1.2s linear infinite;\n}\n\n.lds-spinner div:after {\n    content: \" \";\n    display: block;\n    position: absolute;\n    top: 3px;\n    left: 37px;\n    width: 6px;\n    height: 18px;\n    border-radius: 20%;\n    background: #fff;\n}\n\n.lds-spinner div:nth-child(1) {\n    transform: rotate(0deg);\n    animation-delay: -1.1s;\n}\n\n.lds-spinner div:nth-child(2) {\n    transform: rotate(30deg);\n    animation-delay: -1s;\n}\n\n.lds-spinner div:nth-child(3) {\n    transform: rotate(60deg);\n    animation-delay: -0.9s;\n}\n\n.lds-spinner div:nth-child(4) {\n    transform: rotate(90deg);\n    animation-delay: -0.8s;\n}\n\n.lds-spinner div:nth-child(5) {\n    transform: rotate(120deg);\n    animation-delay: -0.7s;\n}\n\n.lds-spinner div:nth-child(6) {\n    transform: rotate(150deg);\n    animation-delay: -0.6s;\n}\n\n.lds-spinner div:nth-child(7) {\n    transform: rotate(180deg);\n    animation-delay: -0.5s;\n}\n\n.lds-spinner div:nth-child(8) {\n    transform: rotate(210deg);\n    animation-delay: -0.4s;\n}\n\n.lds-spinner div:nth-child(9) {\n    transform: rotate(240deg);\n    animation-delay: -0.3s;\n}\n\n.lds-spinner div:nth-child(10) {\n    transform: rotate(270deg);\n    animation-delay: -0.2s;\n}\n\n.lds-spinner div:nth-child(11) {\n    transform: rotate(300deg);\n    animation-delay: -0.1s;\n}\n\n.lds-spinner div:nth-child(12) {\n    transform: rotate(330deg);\n    animation-delay: 0s;\n}\n\n@keyframes lds-spinner {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
